import { render, staticRenderFns } from "./LogoutSsoCallBack.vue?vue&type=template&id=83c56d28"
import script from "./LogoutSsoCallBack.vue?vue&type=script&lang=js"
export * from "./LogoutSsoCallBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports